export const CONCERN_TYPE_LABEL = {
  SAFEGUARDING: 'Safeguarding',
  BULLYING: 'Bullying',
  EMOTIONAL: 'Emotional',
  PHYSICAL: 'Physical',
  OTHER: 'Other',
};

export const SEVERITY_LABEL = {
  MINOR: 'Minor',
  MODERATE: 'Moderate',
  SEVERE: 'Severe',
};

// Status label tone for each severity (bk-pill--…)
export const SEVERITY_TONE = { MINOR: 'info', MODERATE: 'wait', SEVERE: 'bad' };
